// extracted by mini-css-extract-plugin
module.exports = {"row":"PhoneScreen_row__2TnUl","number":"PhoneScreen_number___dqQF","actions":"PhoneScreen_actions__sAPsJ","error":"PhoneScreen_error__03W5q"};